import React, {useEffect, useState, useContext, useRef, use} from 'react';
import Popup from 'reactjs-popup';
import { MediaUrl } from '../../utils/Media';
import { useFetch } from '../../api/FetchApiData';
import Multiselect from 'multiselect-react-dropdown';
import Select from 'react-select';
import { list_countries } from '../../utils/Media';
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";
import 'react-phone-number-input/style.css';
import { AppContext } from '../../../AppContextProvider';
import { isMobile } from 'react-device-detect';
import { TeachButton } from '../../utils/ButtonLoader';
import { useTranslation } from 'react-i18next';
if (isMobile)
  import('./mob-manufacturer.css').then(() => {});
else
  import('./manufacturer.css').then(() => {});

function ManifacturingForm({action,setManufacturers, manufacturers=[] ,setRayons,rayons=[] , manufacturer={name:"",country:{},phone:"",logo:null, categories:[]}}) {
    
    const [_manufacturer, setManufacturer] = useState(manufacturer)
    const [selmanufactures,setSelManufactures] = useState([]);
    const [imageChanged,setImageChanged] = useState(false);
    const [categories,setCategories] = useState([]);
    const [AppState,setAppState] = useContext(AppContext)
    const fetchData = useFetch({AppState,setAppState});
    const ManInputRef = useRef(null);
    const [selCategories,setSelCategories] = useState([]);
    const [notification,setNotification] = useState({text:"",color:"black"});
    let defaultSelCategories = useRef([]);
    const {t} = useTranslation();

    const MarkedText = (text)=>{
    const elem = text.split("*");
        if (elem.length>1)
        {
          return(<div style={{margin:'0px',padding:'0px',height:'fit-content'}}><span style={{display:'block',fontSize:'small'}}>{elem[0]}</span><span style={{color:'gray',fontSize:'x-small'}}>{elem[1]}</span></div>);
        }
        else{
          return(<label style={{display:'block',fontSize:'small',margin:'0px',padding:'0px'}}>{text}</label>);
        }
      }

    useEffect(()=>{
      if(!!manufacturer.id)
      {
        setManufacturer(manufacturer);
        if(!!manufacturer.categories)
          setSelCategories(categories.flatMap(group => group.options).filter(cat => manufacturer.categories.includes(cat.id)));
      }
    },[manufacturer]);

    useEffect(()=>{
        setSelCategories(categories.flatMap(group => group.options).filter(cat => manufacturer.categories.includes(cat.id)));
      },[categories]);


    useEffect(() => {
      if (action === "Nouveau" || action === "Modifier") {
        const grouped = rayons.map(rayon => ({
          label: rayon.name,           // group header
          options: rayon.categories.map(category => ({
            ...category,
            label: category.name,                  // plain text for search
            displayLabel: MarkedText(category.name), // JSX for display
            value: category,
            rayon: rayon.name,
            caracteristics: JSON.stringify(category.caracteristics),
          }))
        }));
        setCategories(grouped);
      }
    }, [rayons]);

    const filterOption = (option, searchTerm) => {
      if (!searchTerm) return true;

      const normalize = (str) =>
        (str ?? "").toString().toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      return normalize(option.label).includes(normalize(searchTerm));
    };

    const OnCheckBoxChange = (event)=>{
      try{
      const checked_id = event.target.value;
      if(event.target.checked) 
      {selmanufactures.push({id:parseInt(checked_id)});setSelManufactures([...selmanufactures]);}
      else
      {selmanufactures.pop({id:parseInt(checked_id)});setSelManufactures([...selmanufactures]);}
        }
      catch{}
    }
    
    const uploaded_image = ()=>
    {

      if(action==="Modifier" && !imageChanged)
      {
        try{
        let url = MediaUrl(_manufacturer.logo.image);
        return(<img className="man-user-input" style={{width:"200px",height:'200px',display:'inline-block',marginLeft:'10px',borderRadius:'10px'}} src={url}  />);
        }
        catch{}
      }
      else
      {
        try{
          let url = URL.createObjectURL(_manufacturer.logo);
          return(<img className="man-user-input" style={{width:"200px",height:'200px',display:'inline-block',marginLeft:'10px',borderRadius:'10px'}} src={url}  />);
          }
        catch{}
      }

    }

    let trigger_color = (action==="Supprimer") ? '#FFCCCB' : 'lightgreen';
    trigger_color = (action==="Modifier") ? 'lightblue' : trigger_color; 

    const setDataForm=(edition = false)=>
    {
        var cats = [...new Set(_manufacturer.categories)];
        /*
        for(let i=0;i<cats.length;i++)
        {
           cats[i].caracteristics = JSON.stringify(cats[i].caracteristics);
           cats[i].id = cats[i].id;
        }
           */
        var _manufacturer_ = {name:_manufacturer.name, country:JSON.stringify(_manufacturer.country),phone:_manufacturer.phone,categories:cats};
        if(edition)
          _manufacturer_ = {..._manufacturer_,id:_manufacturer.id}
        console.log(_manufacturer_);
        var logo = _manufacturer.logo;
        var formdata = new FormData();
        formdata.append('data',JSON.stringify(_manufacturer_));
        if(imageChanged)
          formdata.append('logo',logo,logo.name);
        return formdata;
    }

    const ExecAction = (close)=>
    {
        if(action==="Nouveau")
        {
          var formdata = setDataForm(false);
          fetchData.PostFormData(formdata,'manufacturer/').then(result=>
              {
                   if(result.result)
                   {
                      setNotification({text:"Fabricant ajouté",color:"green"});
                      setTimeout(()=>{
                        setNotification({text:"",color:"black"});
                        close();
                        setRayons([...result.rayons]);
                        setManufacturers([...result.manufacturers]);
                      })
                   }
                   else
                   {
                      setNotification({text:result.errors[0],color:"orangered"});
                   }
              });
        }
        else if(action==="Modifier")
        {
          var formdata = setDataForm(true);
          fetchData.PutFormData(formdata,'manufacturer/').then(result=>
              {
                  console.log(result);
                   if(result.result)
                   {
                      setNotification({text:"Fabricant Modifié",color:"green"});
                      setTimeout(()=>{
                        setNotification({text:"",color:"black"});
                        close();
                        setRayons([...result.rayons]);
                        setManufacturers([...result.manufacturers]);
                      })
                   }
                   else
                   {
                      setNotification({text:result.errors[0],color:"orangered"});
                   }
              });
        }
    }

    const Cat_Select = (item)=>
    {
      _manufacturer.categories.push(item.id);
      selCategories.push(item);
      setSelCategories([...selCategories]);
    }

    const Cat_Remove = (item)=>
    {
      _manufacturer.categories = _manufacturer.categories.filter(c => 
            (c.id ?? c) !== item.id);
          setSelCategories(prev => prev.filter(c => c.id !== item.id));
        //var cat = categories.find((c)=>c.id===item.id);
        //if(!!cat)
        /*
        _manufacturer.categories.pop(item.id);
        selCategories.pop(item);
        setSelCategories([...selCategories]);
        */
    }

    const handleSearch = (searchTerm) => {   // ← only one argument
      if (!searchTerm) return;

      const normalize = (str) =>
        str.toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      const term = normalize(searchTerm);

      const startsWith = [];
      const contains = [];

      categories.forEach(option => {
        const value = normalize(option.value.name);
        
        if (value.startsWith(term)) {
          startsWith.push(option);
        } else if (value.includes(term)) {
          contains.push(option);
        }
      });
      setCategories([...new Set([...startsWith, ...contains, ...categories])]);
      return [...startsWith, ...contains, ...categories];
    };

    const Form = (close)=>
    {
      if(action === "Nouveau" || action === "Modifier")
      {
        return(
          <>
                <div className='man-div-input'>
                    <label className='man-label'>Nom : </label>
                    <input defaultValue={_manufacturer.name} onChange={e=>{_manufacturer.name = e.target.value}} className='man-user-input' type='text' placeholder='name' />
                </div>
                <div className='man-div-input'>
                    <label className='man-label'>Pays : </label>
                    <div className='man-div-user-input'>
                      <Select options={list_countries} onChange={(value)=>{
                          if(!!_manufacturer.country.name)
                            setManufacturer({..._manufacturer,country:{name:value.value.name,zip:value.value.zip.toLocaleLowerCase()}});
                        }} />
                    </div>
                </div>
                <div className='man-div-input'>
                    <label className='man-label'>Téléphone : </label>
                    <div className='man-div-user-input'>
                      <PhoneInput
                        placeholder="numero de télephone"
                        onChange={(value)=>{setManufacturer({..._manufacturer,phone:value})}}
                        //country={_manufacturer.country.zip}
                        containerStyle={{
                          border: "none",
                          height:'100%'
                        }}
                        inputStyle={{width:'100%',textAlign:'center'}}
                        value={_manufacturer.phone}
                        defaultInputValue={_manufacturer.phone}
                        />
                    </div>
                </div>
                <div className='man-div-input'>
                    <label className='man-label'>Categories : </label>
                    <div className='man-div-user-input'>
                        <Select
                            isMulti
                            options={categories}
                            getOptionLabel={(option) => option.label}
                            formatOptionLabel={(option) => option.displayLabel}
                            getOptionValue={(option) => option.id}
                            value={categories.flatMap(group => group.options).filter(cat => 
                                  _manufacturer.categories.some(c => 
                                    (c.id ?? c) === cat.id   // works whether c is an object or a plain id
                                  ))}
                            filterOption={filterOption}       // ← custom search
                            onChange={(selectedList, { action, removedValue, option }) => {
                              if (action === 'select-option') Cat_Select(option);
                              if (action === 'remove-value') Cat_Remove(removedValue);
                            }}
                          />
                      </div>
                </div>
                <div style={{}} className='man-div-input'>
                    <label className='man-label'>Logo : </label>
                        <div style={{display:'inline-block'}}>
                            <input ref={ManInputRef} style={{display:'none',verticalAlign:'middle',border:'none',height:'40px'}} className='man-user-input' type='File' placeholder='name' multiple={false} onChange={e=>{setManufacturer({..._manufacturer,logo:e.target.files[0]});setImageChanged(true);}} />
                            <button
                              onClick={() => ManInputRef.current.click()}
                              style={{
                                padding: '8px 16px',
                                backgroundColor: 'lightgray',//'#4CAF50',
                                color: 'black',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                              }}
                            >
                              📁 Choisir un fichier
                            </button>
                        </div>
                </div>
                <div style={{}} className="man-div-input">
                    <div style={{textAlign:'center'}}>
                      {uploaded_image()}
                    </div>
                </div>
                <div className='man-div-input' style={{textAlign:'center'}}>
                    <>
                      <input onClick={e=>{ExecAction(close)}} style={{margin:'10px',height:'40px',minWidth:'30%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'lightgreen'}} type='button' value={"Enregister"} />
                      <input onClick={e=>{close();}} style={{margin:'10px',height:'40px',minWidth:'30%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={"Annuler"} />
                      {
                      //<TeachButton id={manufacturer.id} target={'manufacturer'} width={'50%'} />
                      }
                      </>
                </div>
          </>);
      }
      else
      {
        <>
          {manufacturers.map((cat, index)=>{
              return(
                  <div key={index} style={{margin:'auto',width:'80%',border:'1px solid lightgray',padding:'10px',borderRadius:'5px'}}>
                      <label style={{marginRight:'80px'}}>{cat.name}</label>
                      <input type='checkbox' value={cat.id}  onChange={(e)=>{OnCheckBoxChange(e)}} />
                  </div>
              );
          })}
          <div style={{textAlign:'center'}} className="man-div-input">
              <input onClick={(e)=>{ExecAction(close);}} style={{margin:'10px',height:'40px',minWidth:'40%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:trigger_color}} type='button' value={"Supprimer"} />
              <input onClick={close} style={{margin:'10px',height:'40px',minWidth:'40%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={"Annuler"} />
          </div>
        </>
      }
    }

    var btn_text_value = "Nouveau";

    switch(action)
    {
      case "Modifier":
      {btn_text_value = t("ajout-produit.modifier");break;}
      case "Nouveau":
      {btn_text_value = t("ajout-produit.nouveau");break;}
      case "Supprimer":
      {btn_text_value = t("panier.supprimer");break;}
      default:
        break;
    }

  return (
        <Popup trigger={<input disabled={action==="Modifier" && (manufacturer.id===null || manufacturer.id===undefined)} className='btn-popup' style={{backgroundColor:trigger_color}} value={btn_text_value} type='button' />}>
            {
              close =>(
                <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'80px',left:'0px',width:'100%',height:'100vh'}}>
                    <fieldset className='man-fieldset'>
                      <p style={{color:notification.color}}>{notification.text}</p>
                      {Form(close)}
                    </fieldset>
                </div>
              )}
        </Popup>
  )
}

export default ManifacturingForm
